import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import _ from "lodash";
import { HeadingText, ClubCard, Root } from "@components";
import { imageUrlBuilder, getAverageTeeTime } from "@utils";
import { getBestClubsInCountry } from "@redux/teetime/actions";
import { allBestClubsInCountry } from "@redux/teetime/slice";

const LENGTH = 8;

const getDefaultSortOption = (sortOptions) =>
  sortOptions.find((val) => val?.attributes?.isDefault === true);

export const CoursesInCountry = ({ item }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { customDate } = useSelector((store) => store.headerReducer);
  const { coordinates } = useSelector((store) => store.userReducer);
  const { sortingOptions } = useSelector((store) => store.searchReducer);
  const { countryList } = useSelector((store) => store.teetimeReducer);
  const { allBestClubs } = useSelector((store) => store.teetimeReducer);

  const [viewAll, setViewAll] = useState(true);
  const [uniqueData, setUniqueData] = useState([]);
  const [state, setState] = useState({
    data: [],
    filterData: [],
  });

  useEffect(() => {
    if (coordinates?.country) {
      dispatch(
        getBestClubsInCountry({
          date: dayjs(customDate).format("DD-MM-YYYY"),
          country: coordinates?.country,
          sortBy:
            getDefaultSortOption(sortingOptions)?.attributes?.sortBy || "name",
          orderBy:
            getDefaultSortOption(sortingOptions)?.attributes?.orderBy || "asc",
        })
      ).then((data) => {
        if (data?.payload?.data?.length > 0 && data?.payload?.status === 200) {
          setState((prev) => ({
            ...prev,
            data: [
              {
                name: data?.payload?.data[0]?.country,
                list: data?.payload?.data,
              },
            ],
          }));
        }
      });
    }
  }, [coordinates?.country, customDate, JSON.stringify(sortingOptions)]);

  useEffect(() => {
    if (allBestClubs?.length > 0) {
    } else {
      let homeCountryList;
      if (countryList?.length > 0) {
        homeCountryList = countryList?.filter((item) => {
          return item?.showOnHomePage === true;
        });
      }
      if (homeCountryList?.length > 0) {
        homeCountryList?.map(async (e) => {
          await dispatch(
            getBestClubsInCountry({
              date: dayjs(customDate).format("DD-MM-YYYY"),
              country: e?.name,
              sortBy:
                getDefaultSortOption(sortingOptions)?.attributes?.sortBy ||
                "name",
              orderBy:
                getDefaultSortOption(sortingOptions)?.attributes?.orderBy ||
                "asc",
            })
          ).then((data) => {
            if (
              data?.payload?.data?.length > 0 &&
              data?.payload?.status === 200
            ) {
              setState((prev) => ({
                ...prev,
                data: [
                  {
                    name: data?.payload?.data[0]?.country,
                    list: data?.payload?.data,
                  },
                ],
              }));
            }
          });
        });
      }
    }
  }, [countryList, customDate, JSON.stringify(sortingOptions)]);

  useEffect(() => {
    dispatch(allBestClubsInCountry(allBestClubs.concat(state.data)));
  }, [state.data]);

  useEffect(() => {
    const uniqueElements = _.uniqBy(allBestClubs, "name");
    setUniqueData(uniqueElements);
  }, [allBestClubs]);

  const goToCoursesDetails = (e) => navigate(`/course/${e?.id}`);

  return (
    <div className="my-4">
      <Root>
        {uniqueData?.length > 0 &&
          uniqueData?.map((e) => (
            <>
              <div
                className={`flex flex-row lg:py-8 py-6 items-center justify-between`}
              >
                <HeadingText className={`${Heading} font-semibold`}>
                  {`The best courses in ${e?.name}`}
                </HeadingText>
                {e?.list?.length > 8 ? (
                  <button
                    onClick={() => {
                      setViewAll(!viewAll);
                    }}
                  >
                    <span className="text-[15px] font-medium text-[#004996] hover:text-primary">
                      {viewAll ? "View all" : "View less"}
                    </span>
                  </button>
                ) : null}
              </div>

              <ul role="list" className={CoursesGrid}>
                {e?.list
                  ?.slice(0, viewAll === true ? LENGTH : e?.list?.length)
                  .map((client, index) => {
                    const ratings =
                      client?.review_and_ratings?.reduce(
                        (total, next) => total + next?.rating,
                        0
                      ) / client?.review_and_ratings?.length;
                    const onClick = () => goToCoursesDetails(client);
                    let tees_Prices;
                    if (
                      client.tee_times_cachings &&
                      client.tee_times_cachings.length
                    ) {
                      tees_Prices = getAverageTeeTime(client);
                    }
                    return (
                      <ClubCard
                        key={index}
                        goToCoursesDetails={onClick}
                        imgUrl={
                          client?.photos[0] ||
                          imageUrlBuilder(
                            client?.image && client?.image[0]?.url
                          )
                        }
                        name={client?.name}
                        rating={ratings}
                        reviews={client?.review_and_ratings?.length}
                        startTeeTime={tees_Prices?.startTeeTime}
                        lastTeeTime={tees_Prices?.lastteeTime}
                        startPrice={tees_Prices?.startPrice}
                        lastPrice={tees_Prices?.lastPrice}
                        teeTimes={tees_Prices?.tees}
                      />
                    );
                  })}
              </ul>
            </>
          ))}
      </Root>
    </div>
  );
};

const CoursesGrid = `
grid 
xl1:grid-cols-4 
xl:grid-cols-3 
lg2:grid-cols-3 
lg:grid-cols-2 
md2:grid-cols-2 
md:grid-cols-1 
grid-cols-1 
gap-y-8 
gap-x-4 
`;

const Heading = `
lg:text-[28px] 
text-[18px] 
`;
